import React, { useEffect, useState, useContext } from 'react';
import { db } from '../../../firebase';
import { Link } from 'react-router-dom';
import { collection, getDocs, doc, updateDoc, deleteDoc,getDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus, faTrash, faSave } from '@fortawesome/free-solid-svg-icons';
import AddReservationModal from './AddReservationModal';
import EditReservationModal from './EditReservationModal';
import ReactPaginate from 'react-paginate';
import { UserContext } from '../../../contexts/UserContext';
import { Modal, Button } from 'react-bootstrap';

const Reservations = () => {
    const [reservations, setReservations] = useState([]);
    const [editedStatuses, setEditedStatuses] = useState({});
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [selectedReservation, setSelectedReservation] = useState(null);
    const [nameFilter, setNameFilter] = useState('');
    const { user } = useContext(UserContext);

    // For confirmation modal
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [reservationToDelete, setReservationToDelete] = useState(null);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(0);
    const reservationsPerPage = 10;

useEffect(() => {
    const fetchReservations = async () => {
        try {
            const reservationsCollection = collection(db, 'reservation');
            const reservationsSnapshot = await getDocs(reservationsCollection);
            let reservationsList = reservationsSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            // Trier par ID décroissant (ou par date si tu veux)
            reservationsList.sort((a, b) => {
                // Si tu veux trier par ID numérique :
                return parseInt(b.id) - parseInt(a.id);
                
            });

            // Apply name filter
            if (nameFilter) {
                reservationsList = reservationsList.filter(reservation =>
                    reservation.date.toLowerCase().includes(nameFilter.toLowerCase())
                );
            }

            setReservations(reservationsList);
        } catch (error) {
            console.error("Error fetching reservations: ", error);
        }
    };

    fetchReservations();
}, [nameFilter]);


    const indexOfLastReservation = (currentPage + 1) * reservationsPerPage;
    const indexOfFirstReservation = indexOfLastReservation - reservationsPerPage;
    const currentReservations = reservations.slice(indexOfFirstReservation, indexOfLastReservation);
    const pageCount = Math.ceil(reservations.length / reservationsPerPage);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const handleShowEdit = (reservation) => {
        setSelectedReservation(reservation);
        setShowEditModal(true);
    };
    
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };
   
    
    const handleSave = async (updatedReservation) => {


        try {
            let prestation = updatedReservation.prestation;
            if (parseInt(updatedReservation.nbrPersonne) > 9 || parseInt(updatedReservation.nbrPersonne) > 4 && updatedReservation.anniv=='oui') {
                prestation = 5 * updatedReservation.nbrPersonne;
            } else {
                prestation = 0;
            }
            // Ajout des données dans Firestore
            const reservationData = {
                ...updatedReservation,
                prestation,
                 date: formatDate(updatedReservation.date), 
            };

           
            const reservationDoc = doc(db, 'reservation', reservationData.id);
            await updateDoc(reservationDoc, reservationData);
            setReservations((prevReservations) =>
                prevReservations.map((r) =>
                    r.id === reservationData.id ? reservationData : r
                )
            );
            setShowEditModal(false); // Ferme le modal après la sauvegarde

             //  Récupère le modèle d’email
            let emailContent = await getEmailContent('update_reser');
            

            //  Envoie de l’email via  API Node.js
            const emailResponse = await fetch('https://api-7zyk3qftka-uc.a.run.app/api/email-modif-reservation', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                statut: updatedReservation.statut,
                email: updatedReservation.email,
                nom: updatedReservation.nom,
                date: updatedReservation.date,
                heure: updatedReservation.heure,
                nbrPersonne: updatedReservation.nbrPersonne,
                anniv: updatedReservation.anniv,
                typeGateau: updatedReservation.typeGateau,
                texteGateau: updatedReservation.texteGateau,
                ageP: updatedReservation.ageP,
                prestation: updatedReservation.prestation,
                objet: emailContent.objet || `Changement de statut de votre réservation au restaurant Istanbul`,
                emailContent1: emailContent.texte || `Le statut de votre réservation a changé.`,
                emailContent2: emailContent.texte2 || `Nouveau statut : ${updatedReservation.statut}`,
            }),
            });

            if (!emailResponse.ok) {
            console.error("Erreur d'envoi d'email :", await emailResponse.text());
            } else {
            console.log("Email envoyé avec succès !");
            }

        } catch (error) {
            console.error('Erreur lors de la mise à jour de la réservation :', error);
        }
    };
    

    const handleAdd = (newReservation) => {
        setReservations(prevReservations => [...prevReservations, newReservation]);
    };

    const handleDelete = async () => {
        try {
            if (reservationToDelete) {
                await deleteDoc(doc(db, 'reservation', reservationToDelete.id));
                setReservations(prevReservations => prevReservations.filter(p => p.id !== reservationToDelete.id));
                setShowConfirmModal(false);
                setReservationToDelete(null);
            }
        } catch (error) {
            console.error("Erreur lors de la suppression : ", error);
        }
    };

    const showConfirmationModal = (reservation) => {
        setReservationToDelete(reservation);
        setShowConfirmModal(true);
    };

    const hideConfirmationModal = () => {
        setShowConfirmModal(false);
        setReservationToDelete(null);
    };

      const getEmailContent = async (id) => {
            try {
                const emailDoc = await getDoc(doc(db, 'email', id));
                if (emailDoc.exists()) {
                    return emailDoc.data();
                } else {
                    console.error('Document email non trouvé');
                    return '';
                }
            } catch (error) {
                console.error('Erreur lors de la récupération de l\'email:', error);
                return '';
            }
        };

    const handleStatusChange = (reservationId, newStatus) => {
        setEditedStatuses((prevStatuses) => ({
            ...prevStatuses,
            [reservationId]: newStatus,
        }));
    };

const handleSaveStatus = async (reservationId) => {
  const newStatus = editedStatuses[reservationId];
  if (!newStatus) return;

  try {
    // Récupère la réservation actuelle avant mise à jour
    const currentReservation = reservations.find((r) => r.id === reservationId);
    if (!currentReservation) {
      console.error("Réservation introuvable.");
      return;
    }

    // Met à jour le statut dans Firestore
    const reservationDoc = doc(db, "reservation", reservationId);
    await updateDoc(reservationDoc, { statut: newStatus });

    // Objet réservation mis à jour localement
    const updatedReservation = {
      ...currentReservation,
      statut: newStatus,
    };

    // Met à jour localement la liste
    setReservations((prevReservations) =>
      prevReservations.map((reservation) =>
        reservation.id === reservationId
          ? { ...reservation, statut: newStatus }
          : reservation
      )
    );

    // Nettoie le statut édité
    setEditedStatuses((prevStatuses) => {
      const updatedStatuses = { ...prevStatuses };
      delete updatedStatuses[reservationId];
      return updatedStatuses;
    });

    // Choix du template email + API selon le statut
    let emailContent;
    let apiUrl;

    if (newStatus === "confirmé") {
      emailContent = await getEmailContent("confirmation_reser");
      apiUrl = "https://api-7zyk3qftka-uc.a.run.app/api/confirmation-reservation";
    } else if (newStatus === "annulé") {
      emailContent = await getEmailContent("annuler_reser");
      apiUrl = "https://api-7zyk3qftka-uc.a.run.app/api/email-modif-reservation";
    } else {
      emailContent = await getEmailContent("change_statut_reser");
      apiUrl = "https://api-7zyk3qftka-uc.a.run.app/api/email-modif-reservation";
    }

    // Envoi de l’email
    const emailResponse = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        statut: newStatus,
        id: updatedReservation.id,
        email: updatedReservation.email,
        nom: updatedReservation.nom,
        date: updatedReservation.date,
        heure: updatedReservation.heure,
        nbrPersonne: updatedReservation.nbrPersonne,
        anniv: updatedReservation.anniv,
        typeGateau: updatedReservation.typeGateau,
        texteGateau: updatedReservation.texteGateau,
        ageP: updatedReservation.ageP,
        prestation: updatedReservation.prestation,
        objet:
          emailContent?.objet ||
          "Changement de statut de votre réservation au restaurant Istanbul",
        emailContent1:
          emailContent?.texte || "Le statut de votre réservation a changé.",
        emailContent2:
          emailContent?.texte2 || `Nouveau statut : ${newStatus}`,
      }),
    });

    if (!emailResponse.ok) {
      console.error("Erreur d'envoi d'email :", await emailResponse.text());
    } else {
      console.log("Email envoyé avec succès !");
    }
  } catch (error) {
    console.error("Erreur lors de la mise à jour du statut :", error);
  }
};



   const statusColors = {
    soumis: 'badge-pink',       // rose
    'en cours': 'badge-orange', // orange
    confirmé: 'badge-blue',     // bleu
    terminé: 'badge-green',     // vert
    annulé: 'badge-red',        // rouge
};

    return (
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
                <div className="container-fluid">
                    {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                        <button className="btn btn-org ml-auto" onClick={() => setShowAddModal(true)}>
                            <FontAwesomeIcon icon={faPlus} /> Ajouter une reservation
                        </button>
                    )}
                    <p className="mb-4"></p>
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                            <h6 className="m-0 font-weight-bold title-2 mr-2">Reservations</h6>
                            <input
                                type="text"
                                className="form-control w-25"
                                placeholder="Filtrer par date"
                                value={nameFilter}
                                onChange={(e) => setNameFilter(e.target.value)}
                            />
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered" id="dataTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th>Date de reservation</th>
                                            <th>Heure de reservation</th>
                                            <th>Nombre de personnes</th>
                                            <th>Anniversaire oui/non</th>
                                            <th>Montant payé</th>
                                            <th>Statut</th>
                                        
                                            <th>Action</th>
                                            
                                            <th>Nom</th>
                                            <th>Téléphone</th>
                                            <th>Type de gâteau</th>
                                            <th>Personnaliser le gâteau</th>
                                            <th>Age de la personne</th>
                                            <th>Email</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentReservations.map((reservation) => (
                                            <tr key={reservation.id}>
                                                <td>{reservation.date}</td>
                                                <td>{reservation.heure}</td>
                                                <td>{reservation.nbrPersonne}</td>
                                                <td>{reservation.anniv}</td>
                                                <td>{reservation.prestation} €</td>
                                                <td><select
                                                        className={`form-control width-100 ${statusColors[reservation.statut]}`}
                                                     
                                                        value={reservation.statut}
                                                        onChange={(e) =>
                                                            handleStatusChange(reservation.id, e.target.value)
                                                        }
                                                    >
                                                        <option value="soumis">Soumis</option>
                                                        <option value="en cours">En cours</option>
                                                        <option value="confirmé">Confirmé</option>
                                                        <option value="terminé">Terminé</option>
                                                        <option value="annulé">Annulé</option>
                                                    </select></td>
                                                <td className='d-flex'>
                                                    {editedStatuses[reservation.id] && (
                                                                <button
                                                                    className="btn btn-success btn-circle btn-sm"
                                                                    onClick={() => handleSaveStatus(reservation.id)}
                                                                >
                                                                    <FontAwesomeIcon icon={faSave} /> 
                                                                </button>
                                                            )}
                                                            <Link className="btn btn-primary btn-circle btn-sm ml-2" to="#" onClick={() => handleShowEdit(reservation)}>
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </Link>
                                                    {user && user.role === 'Kuo8Wsgg6Q7l4ZGhbTf3' && (
                                                        <>
                                                            
                                                            <Link
                                                                className="btn btn-danger btn-circle btn-sm ml-2" to="#"
                                                                onClick={() => showConfirmationModal(reservation)}
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </Link>
                                                        </>
                                                    )}
                                                </td>
                                                <td>{reservation.nom}</td>
                                                <td>{reservation.tele}</td>
                                                <td>
                                                    {reservation.typeGateau === "personnalise" ? (
                                                        <>
                                                        {reservation.typeGateau} : {reservation.nbChocolat || 0} parts chocolat / {reservation.nbFraises || 0} parts fraise
                                                        </>
                                                    ) : (
                                                        reservation.typeGateau || ""
                                                    )}
                                                </td>

                                                <td>{reservation.texteGateau}</td>
                                                <td>{reservation.ageP}</td>
                                                <td>{reservation.email}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ReactPaginate
                                    previousLabel={'Précédent'}
                                    nextLabel={'Suivant'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination justify-content-end'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AddReservationModal
                show={showAddModal}
                handleClose={() => setShowAddModal(false)}
                handleSave={handleAdd}
            />
            <EditReservationModal
                show={showEditModal}
                handleClose={() => setShowEditModal(false)}
                reservation={selectedReservation}
                handleSave={handleSave}
            />


            {/* Confirmation Modal */}
            <Modal show={showConfirmModal} onHide={hideConfirmationModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer cette réservation ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={hideConfirmationModal}>
                        Annuler
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Supprimer
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Reservations;
